module.exports = __webpack_public_path__ + "static/ojp2-b8a11dea08e8940fbf4bfa5e757144d3.jpg";